<template lang="pug">
y-chip(:label="getStatus" :color="getStatusColor")
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: 'draft'
    },
  },
  computed: {
    getStatus () {
      const status = this.status.split('_').join(' ')
      return status.charAt(0).toUpperCase() + status.slice(1)
    },
    getStatusColor () {
      switch (this.status) {
        case 'pending':
          return 'normal'
        case 'due':
          return 'orange'
        case 'overdue':
          return 'red'
        case 'paid':
          return 'green'
        default:
          return 'grey'
      }
    }
  },

}
</script>

<style scoped>
</style>